import { SearchAndButton } from "./SearchAndButton";


export const Header = () => {
    return (
        <div className="container">
            <h1 className="alert-danger text-center">Dictionary App</h1>

            <SearchAndButton/>
           
        </div>
    );
    }
